import init_price_histogram from "./items/price-histogram";

jQuery(() => {
    init_price_histogram();
});
